import { createAction } from '../../../../store.model';
import { ActionType } from '../chat-menu-dialog.action';
import { ChatNav } from '../model/chat-nav.model';

export interface Navigate {
    nav?: ChatNav;
    ctx?: any;
}

export const navigate = createAction<ActionType, Navigate>(
    ActionType.TC__CM__NAVIGATE,
);
